module.exports = __webpack_public_path__ + "static/img/__horse.953cbfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__horse.jpg
// module id = vRbe
// module chunks = 0